import { portfolioConfig } from '../../../config';

// The resume file is expected to live directly in config/ -- only the
// filename is configurable (see PortfolioConfig.resumeLocation).
const resumeFiles = import.meta.glob<{ default: string }>('../../../config/*.pdf', { eager: true });

export const getResumeUrl = (): string => {
  const path = `../../../config/${portfolioConfig.resumeLocation}`;
  const file = resumeFiles[path];
  if (!file) {
    throw new Error(`Resume file not found in config/: ${portfolioConfig.resumeLocation}`);
  }
  return file.default;
};
